import React from "react";

/**
 * DS SegmentedToggle — figma 1735:138000.
 *
 * 2지선다 탭형 토글. 컨테이너(paper bg, radius 8, padding 4) 안에서 각 아이템이
 * 균등 분배되고, 선택된 아이템만 white bg + accent 텍스트.
 *
 * 시안 기준 폭은 380.5px 이지만 컨테이너에 맞춰 늘어나는 요소라 폭은 사용처에서 지정한다
 * (harness §6-1 반응형 예외).
 *
 * @param {object} props
 * @param {Array<{value: string, label: string, disabled?: boolean}>} props.items
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {boolean} [props.disabled] - 전체 비활성
 */
const DSSegmentedToggle = ({
  items = [],
  value,
  onChange,
  disabled,
  className = "",
  style,
}) => (
  <div className={`ds-segmented ${className}`.trim()} style={style}>
    {items.map((item) => (
      <button
        key={item.value}
        type="button"
        disabled={disabled || item.disabled}
        aria-pressed={item.value === value}
        className={[
          "ds-segmented__item",
          item.value === value && "ds-segmented__item--active",
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={() => onChange && onChange(item.value)}
      >
        {item.label}
      </button>
    ))}
  </div>
);

export default React.memo(DSSegmentedToggle);
